import "../Guide.css";
import Stage from "../../stage/Stage";
import { Link } from "react-router-dom";

function Evade() {
  return (
    <Stage>
      <h1>Evade Armors</h1>
      <p className="guideText">
        This page is for Rubi-ka's Omni-Tek Steel Ribbed and Apocalypse Leather
        Armor sets.
      </p>
      <p className="guideText">
        Both sets are common late game options because of the effort required,
        but can be crafted as early as QLs 25 and 15. The process typically
        involves "rolling" the base steel-ribbed or leather armor, hacking the
        armor set, then applying either of the sided sprays. You may refer to{" "}
        <a
          href="https://www.ao-universe.com/guides/classic-ao/tradeskill-guides-6/armor-5/omni-tek-steel-ribbed-armor"
          className="aboutLink"
          target="_blank"
          rel="noreferrer"
        >
          the AO-Universe crafting guide.
        </a>{" "}
      </p>
      <p className="guideText">
        At the time of writing, Lock Pick of Eight is not obtainable on Project
        Rubi-ka. This means you will have to find a tradeskiller to pass the 6x
        breaking and entering check. The Omnifier and Clanalizer spray items are
        much more common drops on Project Rubi-ka.
      </p>
      <p>
        <Link className="guideLink" to={"/guides/Armors/Omni-Tek-Steel-Ribbed"}>
          Omni-Tek Steel Ribbed
        </Link>
      </p>
      <p>
        <Link className="guideLink" to={"/guides/Armors/Apocalypse-Leather"}>
          Apocalypse Leather
        </Link>
      </p>
    </Stage>
  );
}

export default Evade;
